<template>
<section class="card">
    <h1>{{ t.info.about }}</h1>
    <table class="table">
        <tbody>
            <tr v-if="!profile.isClub">
                <th>{{ t.info.status }}</th>
                <td>
                    <editable :options="statusOptions" :params="profileParams" property="status" type="select"
                        :value="profile.status" :editable="editMode">{{ t.info.not_specified }}</editable>
                </td>
            </tr>
        <tr>
            <th>{{ t.info.location }}</th>
            <td class="profile-location">
                <editable :params="profileParams" property="location" type="location" :inline="false"
                        :value="profile.location ? profile.location : ''" :t="t" :editable="editMode">
                    <template>{{ t.info.not_specified }}</template>
                </editable>
            </td>
        </tr>
        <tr>
            <th>{{ t.info.distance }}</th>
            <td>
                <template>{{ profile.formattedDistance }}</template>
            </td>
        </tr>
        <tr v-if="!profile.isClub && siteType === 'swing'" class="profile-meeting">
            <th>{{ t.info.meeting }}</th>
            <td v-if="editMode">
                <div>{{ t.info.accommodate }}
                    <editable class="pull-right" :options="yesNo" :params="profileParams" property="accommodate" type="select"
                        :value="profile.accommodate ? '1' : '0'"></editable>
                </div>
                <div>{{ t.info.hotel }}
                    <editable class="pull-right" :options="yesNo" :params="profileParams" property="hotel" type="select"
                        :value="profile.hotel ? '1' : '0'"></editable>
                </div>
                <div>{{ t.info.travel }}
                    <editable class="pull-right" :options="yesNo" :params="profileParams" property="travel" type="select"
                        :value="profile.travel ? '1' : '0'"></editable>
                </div>
            </td>
            <td v-else>
                <i :class="['fa', profile.accommodate ? 'fa-check' : 'fa-times']"></i> {{ t.info.accommodate }},&nbsp;
                <i :class="['fa', profile.hotel ? ' fa-check' : 'fa-times']"></i> {{ t.info.hotel }},&nbsp;
                <i :class="['fa', profile.travel ? ' fa-check' : 'fa-times']"></i> {{ t.info.travel }}
            </td>
        </tr>
        <tr>
            <th>{{ t.info.last_online }}</th>
            <td>{{ profile.last_login }}</td>
        </tr>
        <tr>
            <th>{{ t.info.joined }}</th>
            <td>{{ profile.joined }}</td>
        </tr>
        <tr v-if="!localConfig.data.extendedPerson">
            <th>{{ t.info.extras }}</th>
            <td><i :class="['fa', profile.hasExtras ? 'fa-check' : 'fa-times']"></i></td>
        </tr>
        </tbody>
    </table>
</section>
</template>

<script>
import Editable from 'Site/component/Editable.vue';
import { mapState } from 'vuex';

export default {
    name: 'ProfileInfo',
    components: {
        Editable
    },
    computed: {
        ...mapState({
            config: state => state.config.data,
            siteType: state => state.siteConfig.siteType
        }),
        profileParams() {
            return { id: this.config.userId, url: 'profile' };
        },
        statusOptions() { return this.localConfig.data.statuses; }
    },
    data() {
        return {
            yesNo: [
                { value: '1', text: this.t.user_view.yes },
                { value: '0', text: this.t.user_view.no }
            ]
        };
    },
    props: {
        editMode: {
            type: Boolean,
            default: false
        },
        localConfig: {
            type: Object,
            required: true
        },
        profile: {
            type: Object,
            required: true
        },
        t: {
            type: Object,
            required: true
        }
    }
};

</script>
